import React from 'react'

import { Skeleton } from 'components'
import {
  SKELETON_BRANCH_INFO,
  SKELETON_PRODUCT_INFO,
  SKELETON_WARRANTY,
} from 'features/Product/constants'
import { BoxItem, BoxDetailItem } from './ProductDetail'

const SkeletonProductDetail: React.FC = () => {
  const base = 'f-product-detail'

  const SkeletonBranchInfo = () => {
    return (
      <div className={`${base}__branch-info-content`}>
        <div className={`${base}__title-layout`}>
          <span className={`${base}__branch-detail-title`}>
            {<Skeleton.whiteSkeleton width='130px' />}
          </span>
        </div>
        <div className={`${base}__description-layout`}>
          {SKELETON_BRANCH_INFO.map((data, index) => {
            return (
              <BoxItem
                key={index}
                title={<Skeleton.whiteSkeleton width={`${data.widthTitle}`} />}
                description={
                  <Skeleton.whiteSkeleton width={`${data.widthDescription}`} />
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  const SkeletonProductInfo = () => {
    return (
      <div className={`${base}__branch-address-content`}>
        <div className={`${base}__title-warranty-layout`}>
          <span className={`${base}__branch-detail-title`}>
            {<Skeleton.whiteSkeleton width='130px' />}
          </span>
          <div className={`${base}__preview-image-content`}>
            <span className={`${base}__title-text`}>
              {<Skeleton.whiteSkeleton width='56px' />}
            </span>
            <div className={`${base}__thumbnail`}>
              {
                <Skeleton.whiteSkeleton
                  width='325px'
                  height='244px'
                  borderRadius='8px'
                />
              }
            </div>
          </div>
        </div>
        <div>
          <div className={`${base}__description-layout`}>
            {SKELETON_PRODUCT_INFO.map((data, index) => {
              return (
                <BoxItem
                  key={index}
                  title={
                    <Skeleton.whiteSkeleton width={`${data.widthTitle}`} />
                  }
                  description={
                    <Skeleton.whiteSkeleton
                      width={`${data.widthDescription}`}
                    />
                  }
                />
              )
            })}
          </div>
          <BoxDetailItem
            title={<Skeleton.whiteSkeleton width='74px' />}
            description={<Skeleton.whiteSkeleton width='121px' />}
          />
        </div>
      </div>
    )
  }

  const ProductWarranty = () => {
    return (
      <div className={`${base}__branch-info-content`}>
        <div className={`${base}__title-warranty-layout`}>
          <span className={`${base}__warranty-title`}>
            {<Skeleton.whiteSkeleton width='130px' />}
          </span>
          <span className={`${base}__warranty-type-title`}>
            {<Skeleton.whiteSkeleton width='80px' />}
          </span>
        </div>

        <div className={`${base}__description-layout`}>
          {SKELETON_WARRANTY.map((data, index) => {
            return (
              <BoxItem
                key={index}
                title={<Skeleton.whiteSkeleton width={`${data.widthTitle}`} />}
                description={
                  <Skeleton.whiteSkeleton width={`${data.widthDescription}`} />
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <div data-testid='skeleton-loading'>
      <SkeletonBranchInfo />
      <SkeletonProductInfo />
      <ProductWarranty />
    </div>
  )
}

export default SkeletonProductDetail
